import { useMutation } from '@tanstack/react-query'

import { authAPI } from '@/api/new-api'
import { PACKAGES_BASE_QUERY_KEY } from '@/api/packages/get-packages-dashboard'
import { PackageModel, PartialExcept } from '@/models'
import { composeFormData } from '@/utils'
import { resetQueries } from '@/utils/api'

type UpdatePackageRequest = PartialExcept<PackageModel, 'id'>

export const updatePackage = async ({ id, ...data }: UpdatePackageRequest) => {
  const response = await authAPI.put<PackageModel>(`/packages/${id}`, composeFormData(data), {
    headers: {
      'content-type': 'multipart/form-data',
    },
  })
  return response.data
}

export const useUpdatePackage = () => {
  return useMutation({
    mutationFn: updatePackage,
    onSuccess: () => {
      resetQueries([PACKAGES_BASE_QUERY_KEY])
    },
  })
}
